module.exports = __webpack_public_path__ + "static/media/icr_deeplink.59bac57b.png";